// @ts-strict-ignore
import {Pipe, PipeTransform} from "@angular/core";
import {SimEventService} from "@services";
import {from, Observable} from "rxjs";
import {Event} from "@models";

@Pipe({
	name: "getEventByScenarioRecordingId",
	standalone: false,
})
export class GetEventByScenarioRecordingIdPipe implements PipeTransform {
	constructor(private _simEventService: SimEventService) {}

	transform(value: string, ...args: unknown[]): Observable<Event> {
		if (value) {
			return from(this._simEventService.getEventByScenarioRecordingId(value));
		}
		return null;
	}
}
